import editor from './src/index';

module.exports = editor;


// WEBPACK FOOTER //
// ./src/components/editor/index.js